export const PASSWORD_REGEX =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

export const PASSWORD_MESSAGE =
  "Must contain one number and one letter, be at least 8 characters long, contain one of the following special characters !@#$%^&* and no other symbols";
